import * as React from "react";
import { ForgotPassword } from "./ForgotPassword";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoginMutation } from "../../../slices/usersApiSlice";
import { setCredentials } from "../../../slices/authSlice";
import { forgotPassword } from "../../../apiManager/shared/ForgotPassword";
import { useNavigate } from "react-router-dom";

export function LoginForm({ small = false }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [login, { isLoading }] = useLoginMutation();
  const { userInfo } = useSelector((state) => state.auth);
  const { jobData } = useSelector((state) => state.job);

  useEffect(() => {
    async function handleLoginEffect() {
      if (userInfo) {
        switch (userInfo.user.role) {
          case "admin":
            navigate("admin");
            break;
          case "shoveller":
            navigate("helper/profile");
            break;
          case "houseOwner":
            navigate("homeowner/profile");
            break;
          default:
            break;
        }
      }
    }
    handleLoginEffect();
  }, [navigate, userInfo]);

  const handleForgotPassword = () => {
    setIsForgotPasswordOpen(true);
  };

  const handleForgotPasswordSave = async (email) => {
    try {
      const res = await forgotPassword(email);
      if (res.error) {
        setError(res.error);
        return;
      }
      setError("");
      alert("Forgot password email sent successfully.");
    } catch (err) {
      setError(err?.data?.message || err.error);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await login({ email, password }).unwrap();
      if (res.error) {
        setError(res.error);
        return;
      }
      setError("");
      dispatch(setCredentials({ ...res }));
    } catch (err) {
      setError(err?.data?.message || err.error);
    }
  };

  return (
    <form
      className={`flex flex-col justify-between w-full ${small ? "max-w-[284px]" : ""} mt-4`}
      onSubmit={submitHandler}
    >
      <div className="flex flex-col mt-2 w-full">
        {/* Error Alert */}
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4 w-full text-center">
            <strong className="font-bold">Error: </strong>
            <span className="block">{error}</span>
          </div>
        )}
        <div className="flex flex-col w-full text-sm font-medium text-zinc-800">
          <InputField
            icon="https://cdn.builder.io/api/v1/image/assets/TEMP/56f3b7bf872ba8e6e9b5595813fb1e49995932e06af1acac01c785421eea49e2?placeholderIfAbsent=true&apiKey=7f2e90e22cd648eabadd6329c5e7c0cc"
            label="Email"
            placeholder="username@gmail.com"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="mt-3">
            <InputField
              icon="https://cdn.builder.io/api/v1/image/assets/TEMP/e6ebc1ebe875a61f10a98c5fac6040c4c11d5724a53a47182feb383de98396e9?placeholderIfAbsent=true&apiKey=7f2e90e22cd648eabadd6329c5e7c0cc"
              label="Password"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center gap-2 mt-2">
        <button className="bg-black px-8 sm:px-12 py-2 rounded-full mt-2 text-white" type="submit">
          {isLoading ? "Loading..." : "Login"}
        </button>
        <button
          type="button"
          onClick={handleForgotPassword}
          className="text-sm text-right flex items-start text-neutral-400 hover:underline"
        >
          Forgot password?
        </button>
      </div>

      {isForgotPasswordOpen && (
        <ForgotPassword
          isOpen={isForgotPasswordOpen}
          onClose={() => setIsForgotPasswordOpen(false)}
          onSave={handleForgotPasswordSave}
        />
      )}
    </form>
  );
}

function InputField({ icon, label, placeholder, type = "text", ...props }) {
  const id = React.useId();

  return (
    <div className="flex flex-col gap-1 w-full">
      <label htmlFor={id} className="">
        {label}
      </label>
      <div className="flex items-center p-3 w-full bg-white rounded-md ">
        <input
          id={id}
          type={type}
          placeholder={placeholder}
          className="flex-1 bg-transparent outline-none text-sm font-medium text-zinc-800 placeholder:text-[#BFBFBF]"
          {...props}
        />
      </div>
    </div>
  );
}

export function LoginBox({ className = "relative lg:mt-0" }) {
  return (
    <div {...{className}}>
      <div className=" max-w-[400px] border-opacity-20 border border-black bg-[#9CA3AF] bg-opacity-[14.12%] rounded-3xl p-8">
        <h2 className="text-3xl font-bold">Login</h2>
        <div className="w-full lg:w-80 ">
          <LoginForm />
        </div>
      </div>
    </div>
  )
}
